'use client';

import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Legend,
  Tooltip,
  Sector,
} from 'recharts';

import { capitalGraph } from '@/app/[locale]/(new)/(public)/projects/[slug]/_page.css';
import { tokensVars } from '@/app/[locale]/(new)/tokens.css';

interface CapitalGraphProps {
  capitalStructure: {
    name: string;
    share: number;
  }[];
}

// A defined turquoise color chart
const COLORS = [
  '#EDEDED',
  '#D1FEAD',
  '#B3BABE',
  '#ABC3D1',
  '#01D27F',
  '#ABC3D1',
];

export function CapitalGraph({ capitalStructure }: CapitalGraphProps) {
  const data = capitalStructure.map(({ name, share }) => {
    return {
      name,
      value: share,
    };
  });

  return (
    <ResponsiveContainer className={capitalGraph}>
      <PieChart id="capital-graph">
        <Pie
          data={data}
          innerRadius={50}
          outerRadius={70}
          paddingAngle={8}
          dataKey="value"
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          activeShape={(props: any) => {
            const {
              cx,
              cy,
              innerRadius,
              outerRadius,
              startAngle,
              endAngle,
              fill,
            } = props;

            return (
              <g>
                <Sector
                  cx={cx}
                  cy={cy}
                  innerRadius={innerRadius}
                  outerRadius={outerRadius}
                  startAngle={startAngle}
                  endAngle={endAngle}
                  fill={fill}
                />
                <Sector
                  cx={cx}
                  cy={cy}
                  startAngle={startAngle}
                  endAngle={endAngle}
                  innerRadius={outerRadius + 6}
                  outerRadius={outerRadius + 10}
                  fill={fill}
                />
              </g>
            );
          }}
        >
          {data.map((entry, index) => (
            <Cell
              key={entry.name}
              stroke="none"
              fill={COLORS[index % COLORS.length]}
            />
          ))}
        </Pie>
        <Tooltip
          content={(el) => {
            if (el.active && el.payload?.length) {
              return (
                <span>
                  {el.payload[0].name}:<br />
                  {el.payload[0].value}%
                </span>
              );
            }

            return null;
          }}
          wrapperStyle={{
            padding: tokensVars.spacing.xs,
            background: tokensVars.colors.main.white,
            borderRadius: tokensVars.rounded.xs,
          }}
        />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
}
